
import React from 'react';
import SignUpButton from '@/components/auth/SignUpButton';
import { Zap } from 'lucide-react';

const HeroSection = () => {
  return (
    <section className="py-8 sm:py-12 lg:py-16 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          {/* Left Column - Text Content */}
          <div className="flex-1 text-center lg:text-left">
            <h1 
              className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight"
              style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
            >
              ¿Tienes dudas sobre tu situación migratoria?
            </h1>
            
            {/* Cultural Trust Tagline - Prominently placed */}
            <p 
              className="text-base sm:text-lg text-gray-600 mb-4 sm:mb-6 leading-relaxed"
              style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
            >
              Hecho con ❤️ para la comunidad migrante.<br />
              Por latinos, para latinos.
            </p>
            
            {/* Main CTA */}
            <div className="flex flex-col items-center lg:items-start gap-3 mb-4">
              <p 
                className="text-sm sm:text-base text-gray-600 leading-relaxed"
                style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
              >
                Obtén respuestas claras en minutos.
              </p>
              <SignUpButton 
                text="Haz Click Para Empezar"
                className="w-full sm:w-auto px-8 py-4 text-lg font-semibold min-h-[50px] bg-[#2563EB] hover:bg-blue-700 shadow-lg hover:shadow-xl transition-all duration-300"
              />
            </div>
            
            <div className="flex items-center justify-center lg:justify-start gap-2">
              <Zap className="h-4 w-4 text-green-500" />
              <p 
                className="text-sm sm:text-base text-gray-600 leading-relaxed"
                style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
              >
                Completamente gratis después de registrarte. Sin tarjeta de crédito requerida.
              </p>
            </div>
          </div>

          {/* Right Column - Hero Image (Desktop) */}
          <div className="flex-1 flex justify-center lg:justify-end">
            <div className="relative">
              <div className="rounded-full overflow-hidden h-64 w-64 sm:h-80 sm:w-80 lg:h-96 lg:w-96 shadow-md border-2 border-[#E2E8F0]">
                <img 
                  src="/lovable-uploads/b3d8be6e-0b32-4a94-bbbf-67a8fb988aa1.png" 
                  alt="Mujer sonriente usando teléfono móvil" 
                  className="w-full h-full object-cover"
                />
              </div>
              {/* Badge */}
              <div className="absolute -bottom-2 -right-2 bg-white rounded-full px-3 py-2 shadow-lg border border-gray-200">
                <p className="text-xs font-semibold text-gray-700" style={{ fontFamily: 'Inter, system-ui, sans-serif' }}>
                  +2,000 personas ayudadas
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
